// Tab-scoped storage for the public demo session token. sessionStorage (not
// localStorage) deliberately — a demo session belongs to one browser tab, never
// persists across tabs or after the tab closes, and is never sent anywhere except as
// the X-Demo-Session header on API requests (see flowClient.ts).

const DEMO_SESSION_KEY = 'buildahead_demo_session';

export function getDemoSessionToken(): string | null {
  try {
    return sessionStorage.getItem(DEMO_SESSION_KEY);
  } catch {
    return null;
  }
}

export function setDemoSessionToken(token: string): void {
  try {
    sessionStorage.setItem(DEMO_SESSION_KEY, token);
  } catch {
    /* private browsing / storage blocked — demo just won't survive a reload */
  }
}

export function clearDemoSessionToken(): void {
  try {
    sessionStorage.removeItem(DEMO_SESSION_KEY);
  } catch {
    /* ignore */
  }
}
